const businessSettings = {
  title: "Business Settings",
  backLabel: "Settings",
  tabs: {
    business: "Business",
    team: "Team",
    sso: "SSO",
    referral: "Referral program",
  },
  businessDetails: {
    title: "Business details",
    subtitle: "Company details will be changed after moderation",
    editButton: "Edit business details",
    labels: {
      businessName: "Business name",
      businessEmail: "Business email",
      phone: "Phone",
      accountId: "Account ID",
      merchantId: "Merchant ID",
      taxNumberType: "Tax number type",
      taxNumber: "Tax number",
      country: "Country",
      city: "City/Town",
      streetAddress: "Street address",
      houseNumber: "House number",
      apartment: "Apartment, suite, etc.",
      postcode: "Postcode",
      reportingPerson: "Reporting responsible person",
      registrationCode: "Registration code",
      address: "Address",
    },
    form: {
      cancel: "Cancel",
      save: "Save",
      saving: "Saving...",
      businessNamePlaceholder: "Company name",
      businessNameHint: "To change your company name, you'll need to provide a copy of the document that shows your new name, such as:",
      businessNameHintList1: "Extract from trade register",
      businessNameHintList2: "Confirmation statement",
      businessNameHintList3: "Updated registration certificate etc. under the current laws of county of incorporation",
      chooseFile: "Choose file",
      chooseFileHint: "Choose *jpg, *jpeg, *png, *pdf files to upload",
      selectTaxNumberType: "Select tax number type",
      optional: "Optional",
      removeFile: "Remove",
    },
    errors: {
      saveFailed: "Failed to save company information",
      anErrorOccurred: "An error occurred",
    },
  },
  sensitiveActions: {
    title: "Sensitive Actions",
    subtitle: "Owner-level controls for managing account lifecycle and billing",
    showActions: "Show sensitive actions",
    hideActions: "Hide sensitive actions",
    aiOptOut: "Do not use our transactions for machine learning and artificial intelligence",
    cancelSubscription: "Cancel subscription",
    deleteAccount: "Delete account",
  },
  advancedActions: {
    title: "Advanced actions",
    subtitle: "Owner-level controls for managing account lifecycle and billing",
    showActions: "Show advanced actions",
    hideActions: "Hide advanced actions",
    helpImproveAI: {
      title: "Help improve AI",
      description: "Use my transactions to improve machine learning and artificial intelligence",
    },
    cancelSubscription: {
      title: "Cancel subscription",
      description: "Stop your subscription. You will retain access until the end of the billing period",
    },
    deleteAccount: {
      title: "Delete account",
      description: "Permanently delete your account and all associated data. This action cannot be undone",
    },
  },
  team: {
    searchPlaceholder: "Search",
    newMember: "New member",
    addNewMember: "Add new member",
    appItems: {
      ltax: { title: "L'Tax", description: "Description of L'Tax" },
      lepr: { title: "L'EPR", description: "Description of L'EPR" },
      linvoice: { title: "L'Invoice", description: "Description of L'Invoice" },
      lauthorize: { title: "L'Authorize", description: "Description of L'Authorize" },
      lmarketplace: { title: "L'Marketplace", description: "Description of L'Marketplace" },
    },
    tableHeaders: {
      name: "NAME",
      role: "ROLE",
      apps: "APPS",
      actions: "ACTIONS",
    },
    you: "You",
    invitationPending: "Invitation pending",
    allCountries: "All countries",
    showMore: "Show more",
    showLess: "Show less",
    noResults: {
      title: "No results found",
      description: "Your search \"{{search}}\" did not match any members. Please try again or add a new member.",
      clearSearch: "Clear search",
    },
    actions: {
      view: "View",
      manage: "Manage",
      removeMember: "Remove member",
    },
    messages: {
      inviteSent: "Invite sent successfully",
      memberUpdated: "Member updated successfully",
      failedToSendInvite: "Failed to send invite",
      failedToUpdateMember: "Failed to update member",
      failedToRemoveMember: "Failed to remove member",
      anErrorOccurred: "An error occurred",
    },
    modals: {
      addMember: {
        title: "Add new member",
        emailLabel: "Enter team members email address",
        emailPlaceholder: "josh@example.com",
        role: "Role",
        apps: "Apps",
        selectCountries: "Select countries",
        cancel: "Cancel",
        sendInvites: "Send invites",
        loading: "Loading...",
      },
      editMember: {
        cancel: "Cancel",
        saveChanges: "Save changes",
        saving: "Saving...",
      },
      viewMember: {
        role: "Role",
        phoneNumber: "Phone number",
        apps: "Apps",
        twoStepAuth: "Two-step authentication",
        turnedOn: "Turned on",
        turnedOff: "Turned off",
        removeFromTeam: "Remove from team",
        manage: "Manage",
      },
      removeMember: {
        title: "Remove from team",
        description: "This user will lose access to all team apps and data. You can add them back later if needed",
        cancel: "Cancel",
        remove: "Remove",
      },
    },
    validation: {
      emailRequired: "Email is required",
      emailInvalid: "Please enter a valid email address",
    },
  },
  deleteAccount: {
    modals: {
      whatYouNeedToKnow: {
        title: "What you need to know",
        paragraph1: "Please note that if you choose to Delete your Lappa account, you will immediately lose access to your account. Your data will also be scheduled for permanent deletion thirty days later and cannot be recovered after that date. As per our terms of service, we are unable to offer a pro-rata refund for any remaining period of unused subscription.",
        paragraph2: "Alternatively, if you'd like to stop paying for Lappa for now but think you might want to use it again in the future, you can cancel your subscription instead. If you do this, you will lose access to your account immediately but we'll store your account data securely for one year before automatically deleting it. This option would allow you to reactivate your account at any time within one year of the cancellation date.",
        paragraph3: "Please note that you'll need Owner access to your Lappa account to be able to delete your account.",
        agreeLabel: "I have read the above",
        termsAndConditions: "Terms & Conditions",
        agreeSuffix: "and agree to delete my Lappa account",
        cancel: "Cancel",
        delete: "Delete",
      },
      confirmPassword: {
        title: "Confirm your password",
        verifyTitle: "Please verify that you understand the following:",
        verify1: "All of your account information will be permanently erased.",
        verify2: "All of your transactions, tax returns, files, attachments, and uploaded documents will be permanently erased.",
        verify3: "Any Direct Debit mandates you've created through Lappa will be permanently erased.",
        passwordLabel: "Confirm your password",
        passwordPlaceholder: "Enter your password",
        cancel: "Cancel",
        delete: "Delete",
        passwordRequired: "Password is required",
        failedToDelete: "Failed to delete account. Please try again.",
      },
    },
  },
  cancelSubscription: {
    modals: {
      selectSubscription: {
        title: "Select the subscription you want to cancel",
        cancel: "Cancel",
        continue: "Continue",
      },
      reasons: {
        title: "These reasons can help better understand why customers choose to cancel their subscriptions and allow for service improvements",
        tooExpensive: "Too expensive",
        tooExpensiveSubtitle: "The cost of the service seems too high for your business",
        switchedService: "Switched to another service",
        switchedServiceSubtitle: "You chose another company or platform for tax compliance",
        missingFeatures: "Missing necessary features",
        missingFeaturesSubtitle: "The service lacks the features or tools you need",
        businessChanges: "Business structure changes",
        businessChangesSubtitle: "Your business has changed its tax plan or structure in a way that no longer requires these services",
        poorQuality: "Poor service quality",
        poorQualitySubtitle: "You were dissatisfied with the quality of support or services.",
        rarelyUsed: "Rarely used",
        rarelyUsedSubtitle: "The service wasn't used as often as planned",
        other: "Other",
        otherPlaceholder: "Write your reason",
        back: "Back",
        continue: "Continue",
      },
      confirm: {
        title: "Confirm your subscription cancellation",
        descriptionWithDate: "Your subscription will end on {{date}}. After that, you will lose access to tax calculation and reporting.",
        descriptionWithoutDate: "Your subscription will end after the current billing period. After that, you will lose access to tax calculation and reporting.",
        refundTitle: "Refund information",
        refundText: "You will not get a refund since it is a pre-paid membership. The products and services LAPPA provides will remain until your subscription plan expires. Please review our",
        termsAndConditions: "Terms and Conditions",
        keepSubscription: "Keep subscription",
        cancelSubscription: "Cancel subscription",
        failedToCancel: "Failed to cancel subscription. Please try again.",
      },
    },
  },
  sso: {
    title: "Your SSO domains",
    description: "Manage Single Sign-On (SSO) permissions for your team members. As an owner, you can assign specific access rights to each member of your company, ensuring everyone has the permissions they need for their role.",
    addDomain: "Add SSO domain",
    loading: "Loading...",
    verified: "Verified",
    notVerified: "Not verified",
    tableHeaders: {
      domain: "DOMAIN",
      verificationStatus: "VERIFICATION STATUS",
      added: "ADDED",
      ssoStatus: "SSO STATUS",
      actions: "ACTIONS",
    },
    actions: {
      ssoSettings: "SSO settings",
      deleteDomain: "Delete domain",
    },
    emptyState: {
      title: "No results found",
      description: "You currently do not have SSO domains",
    },
    modals: {
      addDomain: {
        title: "Add new SSO Domain",
        editTitle: "SSO settings",
        cancel: "Cancel",
        back: "Back",
        continue: "Continue",
        step1: {
          stepLabel: "Step 1/6",
          helperText: "Add your organisation's email domain",
          domainLabel: "Domain",
          domainPlaceholder: "sso.company.example.com",
        },
        step2: {
          stepLabel: "Step 2/6",
          helperText: "Go to your DNS provider and add a record with the following details. It may take up to 24 hours for them to complete domain verification.",
          domain: "Domain",
          name: "Name",
          record: "Record",
          dnsCode: "DNS Code",
          copyCode: "Copy code",
          copied: "Copied",
          error: "The domain cannot be verified because the domain is not registered",
        },
        step3: {
          stepLabel: "Step 3/6",
          helperText: "Provide the DNS record to verify your domain. The following information can be retrieved from your DNS provider",
          identityProviderUrlLabel: "Identity provider URL",
          identityProviderUrlPlaceholder: "https://sso.example.com/saml/login",
          issuerIdLabel: "Issuer ID",
          issuerIdPlaceholder: "example-sso-idp",
          identityProviderCertificateLabel: "Identity provider certificate",
          identityProviderCertificatePlaceholder: "-----BEGIN CERTIFICATE-----\n...\n-----END CERTIFICATE-----",
        },
        step4: {
          stepLabel: "Step 4/6",
          helperText: "Configure your identity provider with the following settings",
          loading: "Loading service provider details...",
          copied: "{{field}} copied to clipboard",
          copyButton: "Copy",
          copyToClipboard: "Copy to clipboard",
          clickToCopy: "Click to copy",
        },
        step5: {
          stepLabel: "Step 5/6",
          helperText: "Please provide the email address of the user for whom you want to test the configuration. It's important to test your SSO configuration before saving it to avoid errors and prevent locking out users.",
          emailLabel: "Email",
          emailPlaceholder: "email@example.com",
        },
        step6: {
          stepLabel: "Step 6/6",
          helperText: "Validation completed successfully",
          validationFailedSummary: "SSO validation did not complete successfully.",
          failedGenericError:
            "We couldn’t complete SSO validation. Please try again or contact support.",
          failedValidating: "Checking configuration…",
          processing: "Processing... Please complete authentication in the opened window.",
          waiting: "Waiting for authentication to complete...",
          processingTimeoutMessage:
            "The server did not respond in time. Please review your SSO configuration details and try again.",
          authPollingTimeout:
            "We couldn’t confirm SSO authentication in time. Please try again or contact support.",
          validationSteps: {
            samlRequestExpired: "Validate SAML request has not expired",
            validSamlResponse: "Receive valid SAML response",
            validIssuerId: "Validate issuer ID",
            validIdpUrl: "Validate identity provider URL",
            validCertificate: "Validate identity provider certificate",
            userAccessVerified: "Verify user access to domain",
            roleAssertionReceived: "Receive role assertion in SAML response",
            roleAssignmentsValid: "Validate role assignments",
          },
        },
        saveConfiguration: "Save configuration",
        loading: "Loading...",
        stepFlowAriaLabel: "SSO validation steps",
      },
      deleteDomain: {
        title: "Delete SSO Domain",
        description: "Are you sure you want to delete SSO domain {{domain}}?",
        warning: "This action is permanent",
        cancel: "Cancel",
        delete: "Delete",
        error: {
          noDomainId: "Domain ID is missing",
          failed: "Failed to delete SSO domain",
        },
      },
      deactivateConfiguredDomain: {
        title: "Deactivate SSO",
        description:
          "You are about to deactivate SSO for {{domain}}. Team members will not be able to use this SSO configuration until you set it up again.",
        warning: "The domain is not deleted. You can manage SSO again from SSO settings when needed.",
        cancel: "Cancel",
        deactivate: "Deactivate",
        error: {
          noConfigId: "SSO configuration ID is missing",
          failed: "Could not deactivate SSO. Please try again.",
        },
      },
    },
  },
  referralProgram: {
    header: {
      title: "Get €150 for every company you refer",
      subtitle: "They get €300, you get €150 — everyone wins",
      howItWorks: "How it works?",
    },
    linkSection: {
      shareLink: "Share personal referral link",
      copyLink: "Copy link",
      or: "or",
      inviteByEmail: "Invite by email",
      emailPlaceholder: "Enter email address",
      sendInvite: "Send invite",
    },
    rewardsSection: {
      title: "Your rewards",
      subtitle: "You can spend it to pay for LAPPA services",
      balance: "Balance",
      clientsInvited: "Clients invited",
      totalEarned: "Total rewards earned",
    },
    referralsSection: {
      columns: {
        referrals: "Referrals",
        earned: "Earned",
      },
      empty: {
        title: "No results found",
        subtitle: "You currently do not have any referrals",
      },
    },
    howItWorksModal: {
      title: "How it works?",
      subtitle: "Invite a company, and get rewarded when they become a customer",
      close: "Close",
      copyInviteLink: "Copy invite link",
      learnMore: "Learn more",
      hideDetails: "Hide details",
      detailsTitle: "Important details",
      detailsItems: {
        rewardDelay: "Rewards are issued after 60 days of active subscription",
        creditsApply: "Credits apply only to subscription fees",
        creditsNoCombine: "Credits can't be combined with other discounts",
        creditsExpiry: "Credits expire after 12 months",
      },
      steps: {
        inviteCompany: {
          title: "Invite a company",
          description:
            "Share your referral link or send an email invite directly from the platform",
        },
        signUp: {
          title: "They sign up",
          description: "Your referral activates a paid subscription",
        },
        becomeCustomer: {
          title: "They become a paying customer",
          description: "The company registers and starts using the platform",
        },
        getRewarded: {
          title: "Get rewarded",
          description: "After 60 days of active subscription:",
          youGetLabel: "You get",
          youGetAmount: "€150",
          theyGetLabel: "They get",
          theyGetAmount: "€300",
          creditsSuffix: "in credits",
        },
      },
    },
  },
  errors: {
    wrongCode: "Wrong code. Try again.",
    invalidVerificationCode: "Invalid verification code. Try again.",
  },
};

export default businessSettings;
